export enum ImageIconType {
    DELETE = 'delete',
    CHECK = 'check',
    PLUS = 'plus',
}

export type ImageIconTypeUnion = `${ImageIconType}`;
